import { fetchAuditData } from './audit'

const auditApi = {
  fetchAuditData: {
    key: 'FETCH_AUDIT_DATA',
    fn: fetchAuditData,
  },
}

export default auditApi
